import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/SolutionsCloudModernizationPage.head';
import { SolutionsCloudModernizationPage } from '@pages/SolutionsCloudModernizationPage';

export const Route = createFileRoute('/solutions/cloud-modernization')({
  component: SolutionsCloudModernizationPage,
  head: () => head,
});
